import React from 'react';
import { formatPhone } from 'App/utils';
import { patientPropType } from 'Shared/types';
import { PatientCardLabel } from 'App/components/Assessments/sidebar/styles/PatientCard';

const EmergencyContactSection = ({ patient: p }) => {
    const emergencyContactName = `${(p.ecFirstName || '').trim()} ${(p.ecLastName || '').trim()}`.trim();
    const hasEmergencyContactInfo = Boolean(
        emergencyContactName || p.ecTelephone || p.ecMobilePhone || p.ecRelationship
    );

    if (!hasEmergencyContactInfo) return null;

    return (
        <>
            <div style={{ marginTop: '15px' }}>
                <PatientCardLabel>Emergency Contact Information</PatientCardLabel>
            </div>

            {emergencyContactName && (
                <div>
                    <PatientCardLabel>Name</PatientCardLabel> {emergencyContactName}
                </div>
            )}
            {p.ecTelephone && (
                <div>
                    <PatientCardLabel>H</PatientCardLabel> {formatPhone(p.ecTelephone)}
                </div>
            )}
            {p.ecMobilePhone && (
                <div>
                    <PatientCardLabel>M</PatientCardLabel> {formatPhone(p.ecMobilePhone)}
                </div>
            )}
            {p.ecRelationship && (
                <div>
                    <PatientCardLabel>Relationship</PatientCardLabel> {p.ecRelationship}
                </div>
            )}
        </>
    );
};

EmergencyContactSection.propTypes = {
    patient: patientPropType.isRequired,
};

export default EmergencyContactSection;
